import React, { FunctionComponent, useState, ReactNode } from 'react';
import classNames from 'classnames';
import { MdKeyboardArrowDown } from 'react-icons/md';

interface IProps {
  title: string;
  children: ReactNode;
  isOpenByDefault?: boolean;
  className?: string;
}

const Accordion: FunctionComponent<IProps> = ({ title, children, isOpenByDefault = false, className }) => {
  const [isOpen, setIsOpen] = useState(isOpenByDefault);

  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };

  const accordionClasses = classNames('accordion', className);
  const contentClasses = classNames('accordion__content', {
    'accordion-open': isOpen,
  });
  const iconClasses = classNames('accordion__icon', {
    'accordion-open': isOpen,
  });

  return (
    <div className={accordionClasses}>
      <button className="accordion__header" onClick={toggleOpen} type="button">
        <span className="accordion__title">{title}</span>
        <MdKeyboardArrowDown className={iconClasses} onClick={toggleOpen} />
      </button>
      <div className={contentClasses}>
        <div className="accordion__body">{children}</div>
      </div>
    </div>
  );
};

export default Accordion;
